import React , {useState} from 'react'
// import Linkedin from '../../../assets/img/file/linkedin.png'
import {Comment} from '../../../utilities'


function Index() {
    const [number , setNumber] = useState(0)

    return (
        <div className='card-comment'>
            <div className='body'>
                <div className='wrap-title-comment'>
                    <div>
                        <h3 className='name'>{Comment[number].name}</h3>
                        <p className='division'>{Comment[number].division}</p>
                    </div>

                </div>
                <div className=''>
                    <h3 className='course'>{Comment[number].course}</h3>
                    <p className='comment-course'>{Comment[number].comment}</p>
                </div>
            </div>

            <div className='action'>
                <div className='wrap-action'>
                    <div className='next-prev'>
                        <button className={number === 0 ? 'notActive' : 'active'} disabled={number === 0} onClick={() => setNumber(number - 1)}>{'<'}</button>
                        <button className={number + 1 === Comment.length ? 'notActive' : 'active'} disabled={number + 1 === Comment.length} onClick={() => setNumber(number + 1)}>{'>'}</button>
                    </div>
                    <div className='dot'>
                        {
                            Comment.map( (item , index) =>  <button onClick={() => setNumber(index)} className={` ${index === number ? 'active' : 'not-active'} `} style={{border : '1px solid #DC4229' , height : 15 , borderRadius : '100px' , cursor : 'pointer'}} /> )
                        }
                    </div>
                </div>

            </div>
        </div>
    )
}


export default Index
